import {
  CloseIcon,
  DeleteIcon,
  DeletePermanentlyIcon,
  ExportIcon,
  ResetIcon,
} from '@blocksuite/icons/rc';
import type { ReactNode } from 'react';

import {
  FloatingToolbar,
  type FloatingToolbarContentProps,
} from './floating-toolbar';
import * as styles from './list-floating-toolbar.css';

export const ListFloatingToolbar = ({
  content,
  onClose,
  open,
  onDelete,
  onRestore,
  onExport,
  contentProps,
}: {
  open: boolean;
  content: ReactNode;
  onClose: () => void;
  onDelete?: () => void;
  onRestore?: () => void;
  onExport?: () => void;
  contentProps?: FloatingToolbarContentProps;
}) => {
  return (
    <FloatingToolbar
      className={styles.floatingToolbar}
      contentProps={contentProps}
      open={open}
    >
      <FloatingToolbar.Item>{content}</FloatingToolbar.Item>
      <FloatingToolbar.Button onClick={onClose} icon={<CloseIcon />} />
      {(!!onRestore || !!onDelete || !!onExport) && (
        <FloatingToolbar.Separator />
      )}
      {!!onExport && (
        <FloatingToolbar.Button
          onClick={onExport}
          icon={<ExportIcon />}
          data-testid="list-toolbar-export"
        />
      )}
      {!!onRestore && (
        <FloatingToolbar.Button
          onClick={onRestore}
          icon={<ResetIcon />}
          data-testid="list-toolbar-restore"
        />
      )}
      {!!onDelete && (
        <FloatingToolbar.Button
          onClick={onDelete}
          icon={onRestore ? <DeletePermanentlyIcon /> : <DeleteIcon />}
          type="danger"
          data-testid="list-toolbar-delete"
        />
      )}
    </FloatingToolbar>
  );
};
